import { render, staticRenderFns } from "./CustomFieldList.vue?vue&type=template&id=4f46d557&"
import script from "./CustomFieldList.vue?vue&type=script&lang=js&"
export * from "./CustomFieldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports